import { Options } from '@sentry/types';
import * as clientSdk from '@sentry/nextjs/types/client';
import * as serverSdk from '@sentry/nextjs/types/server';
import * as edgeSdk from '@sentry/nextjs/types/edge';

export const config:
	| Options
	| clientSdk.BrowserOptions
	| serverSdk.NodeOptions
	| edgeSdk.EdgeOptions = {
	enabled: !!process.env['NEXT_PUBLIC_SENTRY_DSN'],
	dsn: process.env['NEXT_PUBLIC_SENTRY_DSN'],
	environment: process.env['NEXT_PUBLIC_ENVIRONMENT'],
	autoSessionTracking: false,
	attachStacktrace: true,
	ignoreErrors: [
		'https://reactjs.org/docs/error-decoder.html?invariant=418', // Hydration failed because the initial UI does not match what was rendered on the server.
		'https://reactjs.org/docs/error-decoder.html?invariant=422', // There was an error while hydrating this Suspense boundary. Switched to client rendering.
		'https://reactjs.org/docs/error-decoder.html?invariant=423', // There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root...
		'https://reactjs.org/docs/error-decoder.html?invariant=425', // Text content does not match server-rendered HTML...
	],
	integrations: function (integrations) {
		return integrations.filter(function (integration) {
			return integration.name !== 'Breadcrumbs';
		});
	},
};
